module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00309.499345ff.jpg";